import { render, staticRenderFns } from "./Certificado.vue?vue&type=template&id=9cc73c7a&scoped=true"
import script from "./Certificado.vue?vue&type=script&lang=js"
export * from "./Certificado.vue?vue&type=script&lang=js"
import style0 from "./Certificado.vue?vue&type=style&index=0&id=9cc73c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc73c7a",
  null
  
)

export default component.exports